package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.runtime.Composable
import androidx.compose.ui.graphics.Color
import ru.chm.gradereport.model.AttendanceStatus
import ru.chm.gradereport.ui.theme.BlueAccent
import ru.chm.gradereport.ui.theme.GradeTheme
import ru.chm.gradereport.ui.theme.GreenAccent
import ru.chm.gradereport.ui.theme.YellowAccent

internal val PendingAttendanceColor = Color(0xFFA855F7)

internal fun statusLabel(status: AttendanceStatus?): String = when (status) {
    AttendanceStatus.PRESENT -> "П"
    AttendanceStatus.ABSENT -> "Н"
    AttendanceStatus.LATE -> "О"
    AttendanceStatus.EXCUSED -> "У"
    AttendanceStatus.PENDING -> "·"
    null -> "·"
}

internal fun statusFullLabel(status: AttendanceStatus): String = when (status) {
    AttendanceStatus.PRESENT -> "Присутствовал (П)"
    AttendanceStatus.ABSENT -> "Не был (Н)"
    AttendanceStatus.LATE -> "Опоздал (О)"
    AttendanceStatus.EXCUSED -> "Уважительная (У)"
    AttendanceStatus.PENDING -> "Самоотметка (ожидает подтверждения)"
}

@Composable
internal fun statusColor(status: AttendanceStatus?): Color = when (status) {
    AttendanceStatus.PRESENT -> GreenAccent
    AttendanceStatus.ABSENT -> Color(0xFFF87171)
    AttendanceStatus.LATE -> YellowAccent
    AttendanceStatus.EXCUSED -> BlueAccent
    AttendanceStatus.PENDING -> PendingAttendanceColor
    null -> GradeTheme.colors.textMuted
}

/** True when the cell has no confirmed mark (empty or student self check-in). */
internal fun isUnmarkedAttendance(status: AttendanceStatus?): Boolean =
    status == null || status == AttendanceStatus.PENDING

internal fun nextStatus(current: AttendanceStatus?): AttendanceStatus = when (current) {
    null, AttendanceStatus.PENDING -> AttendanceStatus.PRESENT
    AttendanceStatus.PRESENT -> AttendanceStatus.ABSENT
    AttendanceStatus.ABSENT -> AttendanceStatus.LATE
    AttendanceStatus.LATE -> AttendanceStatus.EXCUSED
    AttendanceStatus.EXCUSED -> AttendanceStatus.PRESENT
}

internal val AllAttendanceStatuses = listOf(
    AttendanceStatus.PRESENT,
    AttendanceStatus.ABSENT,
    AttendanceStatus.LATE,
    AttendanceStatus.EXCUSED,
)
